module.exports = "<div  *ngIf=\"loading\" class=\"app-loading-container\">\r\n  <mat-spinner></mat-spinner>\r\n</div>"